//@ts-ignore
import StackdriverErrorReporter from 'stackdriver-errors-js';

type StackdriverOptions = {user?: string | null, additional?: string}

interface Stackdriver {
  report: (msg: Error | string, options?: StackdriverOptions) => void,
  start: (a: object) => void
}

class ErrorHandler {
  private stackdriver: Stackdriver;

  constructor(ErrorClass: any) {
    this.stackdriver = process.env.NODE_ENV !== 'production' ?
      new ErrorClass() :
      {
        report: console.error,
        start: () => {
        }
      };

    this.stackdriver.start({
      key: process.env.REACT_APP_STACK_DRIVER_KEY || 'AIzaSyADemSsjLl-B1l325lqNc0WwEowP2Agu-8',
      projectId: 'student-coach-e1e95',
      service: 'Payment webview',
      context:{},
      version: '0.1.1'
    });
  }

  report(err: Error | string, options?: StackdriverOptions) {
    return this.stackdriver.report(err, options);
  }
}

export default new ErrorHandler(StackdriverErrorReporter);
